/*
 * 工具
 * */
import moment from "moment";

const tools = {};
// 获取当前年月日
tools.getDate = function(date = new Date(), s = "-") {
    let y = date.getFullYear();
    let m = date.getMonth() + 1;
    let d = date.getDate();
    m = m < 10 ? "0" + m : m;
    d = d < 10 ? "0" + d : d;
    return y + s + m + s + d;
};
// 获取当前月有多少天
tools.getDaysInOneMonth = function(
    year = new Date().getFullYear(),
    month = new Date().getDate()
) {
    month = parseInt(month, 10);
    let d = new Date(year, month, 0);
    return d.getDate();
};
tools.format = function (date,fmt) {
    var o = {
        "M+": date.getMonth() + 1, //月份
        "d+": date.getDate(), //日
        "h+": date.getHours(), //小时
        "m+": date.getMinutes(), //分
        "s+": date.getSeconds(), //秒
        "q+": Math.floor((date.getMonth() + 3) / 3), //季度
        "S": date.getMilliseconds() //毫秒
    };
    if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (date.getFullYear() + "").substr(4 - RegExp.$1.length));
    for (var k in o)
        if (new RegExp("(" + k + ")").test(fmt)) fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
    return fmt;
}
// 匹配中英文
tools.setLan = function(list, name, lan = "EN") {
    list.forEach((item) => {
        item[name] = item[`${name}${lan}`];
        if (item.children && item.children.length) {
            tools.setLan(item.children, name);
        }
    });
    return list;
};

// 获取当前时间
tools.getCurrentTime = function() {
    return moment().format("YYYY-MM-DD hh:mm:ss");
};

tools.browserVersion = function() {
    // 取得浏览器的userAgent字符串
    const userAgent = navigator.userAgent;
    // 判断是否IE<11浏览器
    let isIE =
        userAgent.indexOf("compatible") > -1 && userAgent.indexOf("MSIE") > -1;
    let isIE11 =
        userAgent.indexOf("Trident") > -1 && userAgent.indexOf("rv:11.0") > -1;
    // Edge浏览器
    let isEdge = userAgent.indexOf("Edge") > -1 && !isIE;
    // Firefox浏览器
    let isFirefox = userAgent.indexOf("Firefox") > -1;
    // Opera浏览器
    let isOpera =
        userAgent.indexOf("Opera") > -1 || userAgent.indexOf("OPR") > -1;
    // Chrome浏览器
    let isChrome =
        userAgent.indexOf("Chrome") > -1 &&
        userAgent.indexOf("Safari") > -1 &&
        userAgent.indexOf("Edge") === -1 &&
        userAgent.indexOf("OPR") === -1;
    // Safari浏览器
    let isSafari =
        userAgent.indexOf("Safari") > -1 &&
        userAgent.indexOf("Chrome") === -1 &&
        userAgent.indexOf("Edge") === -1 &&
        userAgent.indexOf("OPR") === -1;
    if (isIE) {
        let reIE = new RegExp("MSIE (\\d+\\.\\d+);");
        reIE.test(userAgent);
        let fIEVersion = parseFloat(RegExp["$1"]);
        if (fIEVersion === 7) {
            return "IE7";
        } else if (fIEVersion === 8) {
            return "IE8";
        } else if (fIEVersion === 9) {
            return "IE9";
        } else if (fIEVersion === 10) {
            return "IE10";
        } else {
            // IE版本<7
            return "IE6";
        }
    } else if (isIE11) {
        return "IE11";
    } else if (isEdge) {
        return "Edge" + userAgent.split("Edge/")[1].split(".")[0];
    } else if (isFirefox) {
        return "Firefox" + userAgent.split("Firefox/")[1].split(".")[0];
    } else if (isOpera) {
        return "Opera" + userAgent.split("OPR/")[1].split(".")[0];
    } else if (isChrome) {
        return (
            "Chrome" +
            userAgent
                .toString()
                .split("Chrome/")[1]
                .toString()
                .split(".")[0]
        );
    } else if (isSafari) {
        return "Safari" + userAgent.split("Safari/")[1].split(".")[0];
    } else {
        return -1;
    }
};
tools.getPCOS = function() {
    let platform = navigator.platform;
    let os = null;
    let isWin = platform === "Win32" || platform === "Windows";
    let isMac =
        platform === "Mac68K" ||
        platform === "MacPPC" ||
        platform === "Macintosh" ||
        platform === "MacIntel";
    if (isWin) {
        os = "window";
    } else if (isMac) {
        os = "mac";
    }
    return os;
};

tools.getNum = function(text) {
    return text.replace(/[^0-9]/gi, "");
};

export default tools;



// WEBPACK FOOTER //
// ./src/utils/tool.js